import { render, staticRenderFns } from "./ScoreHistoryChart.vue?vue&type=template&id=2dd21035&"
import script from "./ScoreHistoryChart.vue?vue&type=script&lang=js&"
export * from "./ScoreHistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports